import { Subject } from "rxjs"

interface IAutomationEvent {
  type: string,
  data: any
}

const automationStream = new Subject<IAutomationEvent>()
let activeAutomation = undefined

const broadcast = (type: string, data: any) => {
  if(type === "REGISTER") {
    activeAutomation = data
  } else if(type === "UNREGISTER" && data === activeAutomation) {
    activeAutomation = undefined
    data = null
  }
  automationStream.next({type, data})
}

const getActiveAutomationId = () => {
  return activeAutomation
}

const automationService = {
  stream: () => automationStream.asObservable(),
  broadcast,
  getActiveAutomationId
}

export default automationService
